"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input } from "rizzui";

export default function CollegeAboutEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Content</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => updateContent("title", v)}
              placeholder="About Our College"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => updateContent("description", v)}
              placeholder="At our College, we believe..."
              multiline
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">College Details</h4>
            <div>
              <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">
                Established Text
              </label>
              <Input
                value={content.establishedText || ""}
                onChange={(e) => updateContent("establishedText", e.target.value)}
                placeholder="e.g. EST. 1971"
                className="!rounded-lg text-sm"
              />
            </div>
            <div>
              <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">
                CTA Link Text
              </label>
              <Input
                value={content.ctaText || ""}
                onChange={(e) => updateContent("ctaText", e.target.value)}
                placeholder="e.g. College Overview"
                className="!rounded-lg text-sm"
              />
            </div>
            <div>
              <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">
                CTA Link URL
              </label>
              <Input
                value={content.ctaLink || ""}
                onChange={(e) => updateContent("ctaLink", e.target.value)}
                placeholder="e.g. #overview"
                className="!rounded-lg text-sm"
              />
            </div>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Statistics</h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 1 Value</label>
                <Input
                  value={content.stat1Value || ""}
                  onChange={(e) => updateContent("stat1Value", e.target.value)}
                  placeholder="e.g. 12,000"
                  className="!rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 1 Label</label>
                <Input
                  value={content.stat1Label || ""}
                  onChange={(e) => updateContent("stat1Label", e.target.value)}
                  placeholder="e.g. Students Enrolled"
                  className="!rounded-lg text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 2 Value</label>
                <Input
                  value={content.stat2Value || ""}
                  onChange={(e) => updateContent("stat2Value", e.target.value)}
                  placeholder="e.g. 450+"
                  className="!rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 2 Label</label>
                <Input
                  value={content.stat2Label || ""}
                  onChange={(e) => updateContent("stat2Label", e.target.value)}
                  placeholder="e.g. Faculty & Staff"
                  className="!rounded-lg text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 3 Value</label>
                <Input
                  value={content.stat3Value || ""}
                  onChange={(e) => updateContent("stat3Value", e.target.value)}
                  placeholder="e.g. 95%"
                  className="!rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 3 Label</label>
                <Input
                  value={content.stat3Label || ""}
                  onChange={(e) => updateContent("stat3Label", e.target.value)}
                  placeholder="e.g. Employment Rate"
                  className="!rounded-lg text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 4 Value</label>
                <Input
                  value={content.stat4Value || ""}
                  onChange={(e) => updateContent("stat4Value", e.target.value)}
                  placeholder="e.g. 50K+"
                  className="!rounded-lg text-sm"
                />
              </div>
              <div>
                <label className="text-[9px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Stat 4 Label</label>
                <Input
                  value={content.stat4Label || ""}
                  onChange={(e) => updateContent("stat4Label", e.target.value)}
                  placeholder="e.g. Alumni Worldwide"
                  className="!rounded-lg text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}
